"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartesiaVoiceLanguage = void 0;
exports.CartesiaVoiceLanguage = {
    En: "en",
    De: "de",
    Es: "es",
    Fr: "fr",
    Ja: "ja",
    Pt: "pt",
    Zh: "zh",
    Hi: "hi",
    It: "it",
    Ko: "ko",
    Nl: "nl",
    Pl: "pl",
    Ru: "ru",
    Sv: "sv",
    Tr: "tr",
};
